import { PERMISSIONS } from './permissionConstants';

/**
 * Single source of truth for admin sidebar items and route permission checks.
 */
export const ADMIN_NAV_ITEMS = [
  {
    label: 'Dashboard',
    to: '/admin/dashboard',
    permissions: [PERMISSIONS.DASHBOARD, PERMISSIONS.DASHBOARD_VIEW],
  },
  {
    label: 'Roles & Permissions',
    to: '/super-admin-roles',
    permissions: [
      PERMISSIONS.ROLES_VIEW,
      PERMISSIONS.ROLES_PERMISSIONS,
      PERMISSIONS.ROLES_CREATE,
      PERMISSIONS.ROLES_UPDATE,
      PERMISSIONS.ROLES_DELETE,
      PERMISSIONS.ROLES_ASSIGN_PERMISSIONS,
    ],
  },
  {
    label: 'Clients',
    to: '/users',
    permissions: [
      PERMISSIONS.CLIENTS,
      PERMISSIONS.CLIENTS_VIEW,
      PERMISSIONS.CLIENTS_VIEW_DETAILS,
      PERMISSIONS.CLIENTS_EXPORT,
      PERMISSIONS.SUPERADMIN_CLIENTS_VIEW,
    ],
  },
  {
    label: 'Team Andy',
    to: '/recruiters',
    permissions: [
      PERMISSIONS.AFFILIATES,
      PERMISSIONS.AFFILIATES_VIEW,
      PERMISSIONS.AFFILIATES_VIEW_DETAILS,
      PERMISSIONS.AFFILIATES_MANAGE_TYPE,
      PERMISSIONS.AFFILIATES_SUPER_VIEW,
      PERMISSIONS.AFFILIATES_ADD_WALLET,
      PERMISSIONS.AFFILIATES_EXPORT,
      PERMISSIONS.AFFILIATES_UPDATE_COMMISSION,
    ],
  },
  {
    label: 'Recruiter Meetings',
    to: '/admin/recruiter-meetings',
    permissions: [
      PERMISSIONS.RECRUITER_MEETINGS,
      PERMISSIONS.RECRUITER_MEETINGS_VIEW,
    ],
  },
  {
    label: 'Properties',
    to: '/admin/properties',
    permissions: [PERMISSIONS.PROPERTY_PROVISIONING],
  },
  {
    label: 'Property Report',
    to: '/admin/property-report',
    permissions: [PERMISSIONS.PROPERTY_REPORT, PERMISSIONS.PROPERTY_REPORT_VIEW],
  },
  {
    label: 'Homestead',
    to: '/admin/homestead',
    permissions: [PERMISSIONS.HOMESTEAD],
  },
  {
    label: 'Protests & Exemptions',
    to: '/admin-protest',
    permissions: [
      PERMISSIONS.PROTESTS_EXEMPTIONS,
      PERMISSIONS.PROTESTS_VIEW,
      PERMISSIONS.PROTESTS_VIEW_DETAILS,
      PERMISSIONS.PROTESTS_APPROVE,
      PERMISSIONS.PROTESTS_REJECT,
      PERMISSIONS.PROTESTS_IN_PROGRESS,
      PERMISSIONS.EXEMPTIONS_VIEW,
      PERMISSIONS.EXEMPTIONS_VIEW_DETAILS,
    ],
  },
  {
    label: 'Payouts',
    to: '/withdraw-request',
    permissions: [PERMISSIONS.PAYOUTS, PERMISSIONS.PAYOUTS_VIEW],
  },
  {
    label: 'Refund Invoices',
    to: '/admin/refund-invoices',
    permissions: [PERMISSIONS.REFUND_INVOICES_VIEW],
  },
  {
    label: 'Referral Requests',
    to: '/referral-request',
    permissions: [
      PERMISSIONS.REFERRAL_REQUESTS,
      PERMISSIONS.REFERRAL_REQUESTS_VIEW,
      PERMISSIONS.REFERRAL_REQUESTS_VIEW_DETAILS,
      PERMISSIONS.REFERRAL_REQUESTS_APPROVE,
      PERMISSIONS.REFERRAL_REQUESTS_REJECT,
    ],
  },
  {
    label: 'Estimate Requests',
    to: '/admin/estimate-requests',
    permissions: [
      PERMISSIONS.ESTIMATE_REQUEST,
      PERMISSIONS.ESTIMATE_REQUEST_VIEW,
      PERMISSIONS.ESTIMATE_REQUEST_ADD,
    ],
  },
  {
    label: 'Referrals',
    to: '/referral',
    permissions: [PERMISSIONS.REFERRALS, PERMISSIONS.REFERRALS_VIEW],
  },
  {
    label: 'Referral Codes',
    to: '/admin/referral-codes',
    permissions: [PERMISSIONS.REFERRALS_CODES],
  },
  {
    label: 'Analytics',
    to: '/admin-analytics',
    permissions: [PERMISSIONS.ANALYTICS, PERMISSIONS.ANALYTICS_VIEW],
  },
  {
    label: 'Grafana',
    permissions: [PERMISSIONS.GRAFANA],
    children: [
      {
        label: 'Server Metrics',
        to: '/admin-grafana/server',
        permissions: [PERMISSIONS.GRAFANA],
      },
      {
        label: 'Container Metrics',
        to: '/admin-grafana/containers',
        permissions: [PERMISSIONS.GRAFANA],
      },
    ],
  },
  {
    label: 'App Version Control',
    to: '/versions',
    permissions: [
      PERMISSIONS.APP_VERSION,
      PERMISSIONS.APP_VERSION_VIEW,
      PERMISSIONS.APP_VERSION_UPDATE,
    ],
  },
  {
    label: 'Client Inbox',
    to: '/admin-chat',
    permissions: [PERMISSIONS.CLIENT_INBOX_VIEW],
  },
  {
    label: 'Coupons',
    to: '/admin-coupons',
    permissions: [
      PERMISSIONS.COUPONS,
      PERMISSIONS.COUPONS_VIEW,
      PERMISSIONS.COUPONS_CREATE,
      PERMISSIONS.COUPONS_UPDATE,
      PERMISSIONS.COUPONS_DELETE,
      PERMISSIONS.COUPONS_TOGGLE,
    ],
  },
  {
    label: 'Recruiters Inbox',
    to: '/affiliate-chat',
    permissions: [
      PERMISSIONS.AFFILIATE_INBOX,
      PERMISSIONS.AFFILIATE_INBOX_VIEW,
      PERMISSIONS.AFFILIATE_INBOX_SEND,
    ],
  },
  {
    label: 'Training Library',
    to: '/training-library',
    permissions: [
      PERMISSIONS.TRAINING_LIBRARY,
      PERMISSIONS.TRAINING,
      PERMISSIONS.TRAINING_VIEW,
      PERMISSIONS.TRAINING_CREATE,
      PERMISSIONS.TRAINING_UPDATE,
      PERMISSIONS.TRAINING_DELETE,
      PERMISSIONS.TRAINING_TOGGLE,
    ],
  },
  {
    label: 'Campaign',
    to: '/campaign',
    permissions: [PERMISSIONS.CAMPAIGN, PERMISSIONS.CAMPAIGN_VIEW],
  },
  {
    label: 'Campaign Lead Step',
    to: '/campaign-leadstep',
    permissions: [PERMISSIONS.CAMPAIGN_LEADS, PERMISSIONS.CAMPAIGN_LEADS_VIEW],
  },
  {
    label: 'Push Notifications',
    to: '/push-notification',
    permissions: [
      PERMISSIONS.PUSH_NOTIFICATIONS,
      PERMISSIONS.NOTIFICATIONS_VIEW,
      PERMISSIONS.NOTIFICATIONS_CREATE,
      PERMISSIONS.NOTIFICATIONS_SEND,
      PERMISSIONS.NOTIFICATIONS_VIEW_DETAILS,
    ],
  },
  {
    label: 'Partners',
    to: '/admin/partners',
    permissions: [
      PERMISSIONS.PARTNERS_VIEW,
      PERMISSIONS.DASHBOARD,
      PERMISSIONS.DASHBOARD_VIEW,
    ],
  },
  {
    label: 'Blogs',
    permissions: [
      PERMISSIONS.CMS_BLOGS_VIEW,
      PERMISSIONS.CMS_BLOGS_CREATE,
      PERMISSIONS.CMS_BLOGS_UPDATE,
      PERMISSIONS.CMS_BLOGS_PUBLISH,
      PERMISSIONS.CMS_BLOGS_DELETE,
      PERMISSIONS.CMS_MANAGE,
    ],
    children: [
      {
        label: 'All Blogs',
        to: '/admin/blogs',
        permissions: [PERMISSIONS.CMS_BLOGS_VIEW, PERMISSIONS.CMS_MANAGE],
      },
      // {
      //   label: 'Add New Blog',
      //   to: '/admin/blogs/new',
      //   permissions: [PERMISSIONS.CMS_BLOGS_CREATE, PERMISSIONS.CMS_BLOGS_UPDATE, PERMISSIONS.CMS_MANAGE],
      // },
    ],
  },
  {
    label: 'News & Updates',
    permissions: [
      PERMISSIONS.CMS_NEWS_VIEW,
      PERMISSIONS.CMS_NEWS_CREATE,
      PERMISSIONS.CMS_NEWS_UPDATE,
      PERMISSIONS.CMS_NEWS_PUBLISH,
      PERMISSIONS.CMS_NEWS_DELETE,
      PERMISSIONS.CMS_MANAGE,
    ],
    children: [
      {
        label: 'All News',
        to: '/admin/news',
        permissions: [PERMISSIONS.CMS_NEWS_VIEW, PERMISSIONS.CMS_MANAGE],
      },
      // {
      //   label: 'Add New News',
      //   to: '/admin/news/new',
      //   permissions: [PERMISSIONS.CMS_NEWS_CREATE, PERMISSIONS.CMS_NEWS_UPDATE, PERMISSIONS.CMS_MANAGE],
      // },
      // {
      //   label: 'All Updates',
      //   to: '/admin/updates',
      //   permissions: [PERMISSIONS.CMS_NEWS_VIEW, PERMISSIONS.CMS_MANAGE],
      // },
      // {
      //   label: 'Add New Update',
      //   to: '/admin/updates/new',
      //   permissions: [PERMISSIONS.CMS_NEWS_CREATE, PERMISSIONS.CMS_NEWS_UPDATE, PERMISSIONS.CMS_MANAGE],
      // },
    ],
  },
  {
    label: 'Authors',
    permissions: [
      PERMISSIONS.CMS_AUTHORS_VIEW,
      PERMISSIONS.CMS_AUTHORS_CREATE,
      PERMISSIONS.CMS_AUTHORS_UPDATE,
      PERMISSIONS.CMS_AUTHORS_DELETE,
      PERMISSIONS.CMS_MANAGE,
    ],
    children: [
      {
        label: 'All Authors',
        to: '/admin/authors',
        permissions: [PERMISSIONS.CMS_AUTHORS_VIEW, PERMISSIONS.CMS_MANAGE],
      },
      // {
      //   label: 'Add New Author',
      //   to: '/admin/authors/new',
      //   permissions: [PERMISSIONS.CMS_AUTHORS_CREATE, PERMISSIONS.CMS_AUTHORS_UPDATE, PERMISSIONS.CMS_MANAGE],
      // },
    ],
  },
  {
    label: 'Categories',
    to: '/admin/categories',
    permissions: [PERMISSIONS.CMS_TAXONOMY_VIEW, PERMISSIONS.CMS_TAXONOMY_MANAGE, PERMISSIONS.CMS_MANAGE],
  },
  {
    label: 'Tags',
    to: '/admin/tags',
    permissions: [PERMISSIONS.CMS_TAXONOMY_VIEW, PERMISSIONS.CMS_TAXONOMY_MANAGE, PERMISSIONS.CMS_MANAGE],
  },
  {
    label: 'Media Library',
    to: '/admin/media-library',
    permissions: [PERMISSIONS.CMS_MEDIA_VIEW, PERMISSIONS.CMS_MEDIA_UPLOAD, PERMISSIONS.CMS_MEDIA_DELETE, PERMISSIONS.CMS_MANAGE],
  },
  // {
  //   label: 'Pages',
  //   to: '/admin/pages',
  //   permissions: [PERMISSIONS.CMS_MANAGE],
  // },
  // {
  //   label: 'Comments',
  //   to: '/admin/comments',
  //   permissions: [PERMISSIONS.CMS_MANAGE],
  // },
  {
    label: 'Subscribers',
    to: '/admin/subscribers',
    permissions: [
      PERMISSIONS.CMS_SUBSCRIBERS_VIEW,
      PERMISSIONS.CMS_SUBSCRIBERS_MANAGE,
      PERMISSIONS.CMS_MANAGE,
    ],
  },
  // {
  //   label: 'Settings',
  //   to: '/admin/cms-settings',
  //   permissions: [PERMISSIONS.CMS_MANAGE],
  // },
  {
    label: 'FAQs',
    to: '/admin/faqs',
    permissions: [
      PERMISSIONS.CMS_FAQS_VIEW,
      PERMISSIONS.CMS_FAQS_CREATE,
      PERMISSIONS.CMS_FAQS_UPDATE,
      PERMISSIONS.CMS_FAQS_DELETE,
      PERMISSIONS.CMS_MANAGE,
    ],
  },
];

/** Routes not listed in sidebar but still permission-guarded */
export const ADMIN_EXTRA_ROUTE_PERMISSIONS = {
  '/admin/blogs/new': [PERMISSIONS.CMS_BLOGS_CREATE, PERMISSIONS.CMS_BLOGS_UPDATE, PERMISSIONS.CMS_MANAGE],
  '/admin/news/new': [PERMISSIONS.CMS_NEWS_CREATE, PERMISSIONS.CMS_NEWS_UPDATE, PERMISSIONS.CMS_MANAGE],
  '/admin/updates/new': [PERMISSIONS.CMS_NEWS_CREATE, PERMISSIONS.CMS_NEWS_UPDATE, PERMISSIONS.CMS_MANAGE],
  '/admin/authors/new': [PERMISSIONS.CMS_AUTHORS_CREATE, PERMISSIONS.CMS_AUTHORS_UPDATE, PERMISSIONS.CMS_MANAGE],
  '/admin/blogs/edit': [PERMISSIONS.CMS_BLOGS_UPDATE, PERMISSIONS.CMS_MANAGE],
  '/admin/news/edit': [PERMISSIONS.CMS_NEWS_UPDATE, PERMISSIONS.CMS_MANAGE],
  '/admin/updates/edit': [PERMISSIONS.CMS_NEWS_UPDATE, PERMISSIONS.CMS_MANAGE],
  '/admin/authors/edit': [PERMISSIONS.CMS_AUTHORS_UPDATE, PERMISSIONS.CMS_MANAGE],
  '/admin/estimate-requests/new': [
    PERMISSIONS.ESTIMATE_REQUEST,
    PERMISSIONS.ESTIMATE_REQUEST_VIEW,
    PERMISSIONS.ESTIMATE_REQUEST_ADD,
  ],
  '/sales/estimate-requests': [
    PERMISSIONS.ESTIMATE_REQUEST,
    PERMISSIONS.ESTIMATE_REQUEST_VIEW,
    PERMISSIONS.ESTIMATE_REQUEST_ADD,
  ],
  '/sales/estimate-requests/new': [
    PERMISSIONS.ESTIMATE_REQUEST,
    PERMISSIONS.ESTIMATE_REQUEST_VIEW,
    PERMISSIONS.ESTIMATE_REQUEST_ADD,
  ],
  '/admin/notifications': [
    PERMISSIONS.CAMPAIGN_MANAGE,
    PERMISSIONS.CMS_MANAGE,
    PERMISSIONS.HOMESTEAD_MANAGE,
  ],
  '/reports': [PERMISSIONS.ANALYTICS, PERMISSIONS.ANALYTICS_VIEW],
  '/admin-badges': [PERMISSIONS.ANALYTICS, PERMISSIONS.ANALYTICS_VIEW],
  '/activation': [PERMISSIONS.CAMPAIGN, PERMISSIONS.CAMPAIGN_VIEW],
  '/admin-grafana': [PERMISSIONS.GRAFANA],
};

const flattenNavRoutes = (items) => {
  const routes = [];
  items.forEach((item) => {
    if (item.to) routes.push(item);
    if (item.children?.length) routes.push(...flattenNavRoutes(item.children));
  });
  return routes;
};

export const getPermissionsForRoute = (path) => {
  const navItem = flattenNavRoutes(ADMIN_NAV_ITEMS).find((item) => item.to === path);
  if (navItem) return navItem.permissions;
  return ADMIN_EXTRA_ROUTE_PERMISSIONS[path] || [];
};

export const buildRoutePermissionsMap = () => {
  const map = { ...ADMIN_EXTRA_ROUTE_PERMISSIONS };
  flattenNavRoutes(ADMIN_NAV_ITEMS).forEach((item) => {
    map[item.to] = item.permissions;
  });
  return map;
};

const matchAnyPermission = (userPermissions, requiredPermissions) => {
  const safe = Array.isArray(userPermissions) ? userPermissions : [];
  if (!requiredPermissions?.length) return false;
  return requiredPermissions.some((p) => safe.includes(p));
};

export const ROUTE_PERMISSIONS = buildRoutePermissionsMap();

export const getRoutePermissions = (route) => {
  if (route) {
    if (route.startsWith('/admin/blogs/edit/')) return ROUTE_PERMISSIONS['/admin/blogs/edit'] || [];
    if (route.startsWith('/admin/news/edit/')) return ROUTE_PERMISSIONS['/admin/news/edit'] || [];
    if (route.startsWith('/admin/updates/edit/')) return ROUTE_PERMISSIONS['/admin/updates/edit'] || [];
    if (route.startsWith('/admin/authors/edit/')) return ROUTE_PERMISSIONS['/admin/authors/edit'] || [];
  }
  return ROUTE_PERMISSIONS[route] || [];
};

export const getDefaultAdminPath = (userPermissions) => {
  for (const item of ADMIN_NAV_ITEMS) {
    if (!matchAnyPermission(userPermissions, item.permissions)) continue;
    if (item.to) return item.to;
    const firstChild = item.children?.find((child) =>
      matchAnyPermission(userPermissions, child.permissions)
    );
    if (firstChild?.to) return firstChild.to;
  }
  return '/unauthorized';
};

export const canAccessRoute = (userPermissions, route) => {
  const requiredPermissions = getRoutePermissions(route);
  if (requiredPermissions.length === 0) return true;
  return matchAnyPermission(userPermissions, requiredPermissions);
};
